import Vue from 'vue'
import Router from 'vue-router'
import service from '@/utils/service'
import store from '@/store/store'
import i18n from '@/locale/game';
import axios from '@/utils/axios'

Vue.use(Router)

const errors = [
  {
    path: '/404',
    name: '404',
    component: () => import('../views/game/error'),
    meta:{
      id: '404',
      title: "访问错误",
      code: 404,
      msg: '抱歉，您访问的页面不存在',
    }
  },
  {
    path: '/403',
    name: '403',
    component: () => import('../views/game/error'),
    meta:{
      id: '403',
      title: "访问错误",
      code: 403,
      msg: '抱歉，你无权访问该页面',
    }
  },
  {
    path: '/500',
    name: '500',
    component: () => import('../views/game/error'),
    meta:{
      id: '500',
      title: "访问错误",
      code: 500,
      msg: "抱歉，服务器出错了",
    }
  }
]

export function combineRouter(modules, proj_name, callback) {
  if(!proj_name) {
    proj_name = '游戏详情'
  }
  const routes = [{
    path: '/',
    redirect: modules.length>0?`/${modules[0].ctrl}`:'/menu',
  }, {
    path: '/menu',
    name: 'menu',
    component: () => import('../views/game/menu'),
    meta:{
      id: 0,
      title: `${proj_name}-游戏专项菜单页面`,
    }
  }, {
    path: '/dim',
    name: 'dim',
    component: () => import('../views/game/dim'),
    meta:{
      id: -1,
      title: `${proj_name}-游戏配置页面`,
    }
  }]

  // 固定模块页面
  modules.forEach((item) => {
    routes.push({
      path: `/${item.ctrl}`,
      name: `${item.ctrl}`,
      meta: {
        id: item.id,
        title: `${proj_name}-${i18n.t(`fixed.${item.ctrl}.title`)}`,
      },
      component:  () => import(`../views/game/fixed`),
    })
  })
  // 如果没有测试页面 
  if(!_.find(modules,{ctrl:'test'})) {
    routes.push({
      path: '/test',
      redirect: modules.length>0?`/${modules[0].ctrl}`:'/menu',
    })
  }
  

  let combine_routes = [{
    path:'/',
    component: () => import('../views/game/main'),
    children: routes
  }, {
    path: '/page',
    name: 'page',
    component: () => import('../views/game/page'),
    meta:{
      id: 0,
      title: `${proj_name}-游戏专项页面`,
    }
  }]
  combine_routes = combine_routes.concat(errors)
  const router = new Router({
    routes: combine_routes,
  })
  router.beforeEach((to, from, next) => {
    if(['/realtime', '/pay', '/new', '/online', '/report', '/test', '/consume', '/version'].indexOf(to.path) >= 0) {
      service.log('page', to.path.substring(1), '', '', -1, to.name?'':'无权限')
    }
    if(!to.name) {
      router.push({name:'404'})
      return
    }
    else {
      // 路由发生变化修改页面title
      //document.getElementsByTagName('html')[0].lang = 'zh-CN';
      if (to.meta.title) {
        document.title = to.meta.title
      }
      window.WaterMark.mark({text:store.state.user.username})
      // if(!store.state.user.email) {
      //   await store.dispatch('get_user')
      // }
      // if (store.state.user.email) {
      //   let path = to.matched[to.matched.length-1].path
      //   let page_data = {
      //     "uuid": "5eb374d3f1d462a18cfc01c9",
      //     "mail": store.state.user.email,
      //     "page": path? path:to.matched[to.matched.length-1].name
      //   }
      //   axios.post("https://qa.leihuo.netease.com:19714/api/web_count/page/add", page_data).then(res => {
      //     console.log(res)
      //   }).catch(err => {
      //     console.log(err)
      //   })
      // }
      next()
      return
    }
  })

  router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
  });

  callback(router)
}

const default_router = new Router({
  base: "/data/",
  routes: errors
})
default_router.beforeEach((to, from, next) => {
  if(!to.name) {
    router.push({name:'404'})
    return
  }
  else {
    // 路由发生变化修改页面title
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
    return
  }
})
export const router = default_router